import { authApi } from '../utils/authapi'

//City
export function cityMapping(payload) {
    return authApi(`/lookup/cityMapping`, {
        method: "POST",
        body: payload
    })
}

export function getWorkTypeCity(payload) {
    return authApi(`/lookup/workTypeCity`, {
        method: "POST",
        body: {
            ids: payload
        }
    })
}

export function getCity() {
    return authApi(`/lookup/city`, {
        method: 'GET'
    });
}

export function getCitys(work_type) {
    return authApi(`/lookup/citys?work_type=${work_type}`, {
        method: 'GET'
    });
}

export function createCity(payload) {
    return authApi(`/lookup/createCity`, {
        method: "POST",
        body: payload
    })
}

export function updateCity(payload, cityId) {
    return authApi(`/lookup/updateCity?cityId=${cityId}`, {
        method: "POST",
        body: payload
    })
}

export function getCityList(workType) {
    return authApi(`/lookup/list/city?workType=${workType}`, {
        method: 'GET'
    });
}

export function deleteCity(id) {
    return authApi(`/lookup/delete-city?id=${id}`, {
        method: 'DELETE'
    });
}

//Zone
export function zoneMapping(payload) {
    return authApi(`/lookup/zoneMapping`, {
        method: "POST",
        body: payload
    })
}

export function getCityZone(projectId, payload) {
    return authApi(`/lookup/cityZone?projectId=${projectId}`, {
        method: "POST",
        body: {
            ids: payload
        }
    })
}

export function getRegCityZone(projectId, token, payload) {
    return authApi(`/register/reg-cityZone?token=${token}&projectId=${projectId}`, {
        method: "POST",
        body: {
            ids: payload
        }
    })
}

export function getZone() {
    return authApi(`/lookup/zone`, {
        method: 'GET'
    });
}

export function getMyZone() {
    return authApi(`/lookup/my-zone`, {
        method: 'GET'
    });
}

export function getZoneList(projectId, city) {
    return authApi(`/lookup/list/zone?projectId=${projectId}&city=${city}`, {
        method: 'GET'
    });
}

export function createZone(payload) {
    return authApi(`/lookup/createZone`, {
        method: "POST",
        body: payload
    })
}

export function updateZone(payload, zoneId) {
    return authApi(`/lookup/updateZone?zoneId=${zoneId}`, {
        method: "POST",
        body: payload
    })
}

export function getZoneByMyWorkType(project, city) {
    return authApi(`/lookup/my-zone-city?project=${project}&city=${city}`, {
        method: 'GET'
    });
}

export function getAllZoneByCity(project, city) {
    return authApi(`/lookup/my-all-zone-city?project=${project}&city=${city}`, {
        method: 'GET'
    });
}

export function getZoneByMyProjectWorkType(type, project) {
    return authApi(`/lookup/my-zones-pw?project=${project}&type=${type}`, {
        method: 'GET'
    });
}

export function getCompanyZoneByMyWorkType(clientId) {
    return authApi(`/lookup/client-zone-worktype?clientId=${clientId}`, {
        method: 'GET'
    });
}

export function deleteZone(id) {
    return authApi(`/lookup/delete-zone?id=${id}`, {
        method: 'DELETE'
    });
}

export function getLookupCityProject(id) {
    return authApi(`/lookup/project-city?id=${id}`, {
        method: 'GET'
    });
}

export function getLookupRegCityProject(id) {
    return authApi(`/dashboard/trans-project-city?id=${id}`, {
        method: 'GET'
    });
}

export function getRegLookupCityProject(id) {
    return authApi(`/register/reg-project-city?id=${id}`, {
        method: 'GET'
    });
}

//Designation
export function projectDesignation(projects) {
    return authApi(`/lookup/projectDesignation`, {
        method: 'POST',
        body: {
            ids: projects
        }
    });
}
export function getDesignation() {
    return authApi(`/lookup/designation`, {
        method: 'GET'
    });
}

export function createDesignation(payload) {
    return authApi(`/lookup/createDesignation`, {
        method: "POST",
        body: payload
    })
}

export function updateDesignation(payload, designationId) {
    return authApi(`/lookup/updateDesignation?designationId=${designationId}`, {
        method: "POST",
        body: payload
    })
}

export function getDesignationList(project) {
    return authApi(`/lookup/list/designation?project=${project}`, {
        method: 'GET'
    });
}

export function deleteDesignation(id) {
    return authApi(`/lookup/delete-designation?id=${id}`, {
        method: 'DELETE'
    });
}

//WorkType
export function getAllWorkType(managerId) {
    return authApi(`/lookup/allWorkType?managerId=${managerId}`, {
        method: 'GET'
    });
}

export function projectWorkType(projects) {
    return authApi(`/lookup/projectWorkType`, {
        method: 'POST',
        body: {
            ids: projects
        }
    });
}

export function projectCities(projects) {
    return authApi(`/lookup/projectWorkType`, {
        method: 'POST',
        body: {
            ids: projects
        }
    });
}

export function getWorkType() {
    return authApi(`/lookup/workType`, {
        method: 'GET'
    });
}

export function getWorkTypes(project) {
    return authApi(`/lookup/workTypes?project=${project}`, {
        method: 'GET'
    });
}

export function createWorkType(payload) {
    return authApi(`/lookup/createWorkType`, {
        method: "POST",
        body: payload
    })
}

export function updateWorkType(payload, workTypeId) {
    return authApi(`/lookup/updateWorkType?workTypeId=${workTypeId}`, {
        method: "POST",
        body: payload
    })
}

export function getWorkTypeList(project) {
    return authApi(`/lookup/list/workType?project=${project}`, {
        method: 'GET'
    });
}

export function deleteWorkType(id) {
    return authApi(`/lookup/delete-type?id=${id}`, {
        method: 'DELETE'
    });
}

//ProjectType
export function getProjectType() {
    return authApi(`/lookup/projectType`, {
        method: 'GET'
    });
}

export function getRegProjectType(token) {
    return authApi(`/register/reg-projectType?token=${token}`, {
        method: 'GET'
    });
}

export function createProjectType(payload) {
    return authApi(`/lookup/createProjectType`, {
        method: "POST",
        body: payload
    })
}

export function updateProjectType(payload, projectTypeId) {
    return authApi(`/lookup/updateProjectType?projectTypeId=${projectTypeId}`, {
        method: "POST",
        body: payload
    })
}

export function getProjectTypeList() {
    return authApi(`/lookup/list/projectType`, {
        method: 'GET'
    });
}

export function deleteProjectType(id) {
    return authApi(`/lookup/delete-project?id=${id}`, {
        method: 'DELETE'
    });
}

//SalaryScheme
export function getSalaryScheme() {
    return authApi(`/lookup/salaryScheme`, {
        method: 'GET'
    });
}

export function createSalaryScheme(payload) {
    return authApi(`/lookup/createSalaryScheme`, {
        method: "POST",
        body: payload
    })
}

export function updateSalaryScheme(payload, salarySchemeId) {
    return authApi(`/lookup/updateSalaryScheme?salarySchemeId=${salarySchemeId}`, {
        method: "POST",
        body: payload
    })
}

export function getSalarySchemeList() {
    return authApi(`/lookup/list/salaryScheme`, {
        method: 'GET'
    });
}

export function deleteSalaryScheme(id) {
    return authApi(`/lookup/delete-scheme?id=${id}`, {
        method: 'DELETE'
    });
}

// Bankinfo
export function updateBankInfo(payload, bankId) {
    return authApi(`/lookup/updateBankInfo?bankId=${bankId}`, {
        method: "POST",
        body: payload
    })
}

export function getUpdateBankInfo() {
    return authApi(`/lookup/bankInfo`, {
        method: 'GET'
    });
}

export function getUpdateBankInfoList() {
    return authApi(`/lookup/bankInfoList`, {
        method: 'GET'
    });
}

//Menus
export function getMenus() {
    return authApi(`/lookup/list/menus`, {
        method: 'GET'
    });
}

export function getAdminMenus(client_id) {
    return authApi(`/lookup/list/admin_menus?client_id=${client_id}`, {
        method: 'GET'
    });
}

export function getMenuTypes() {
    return authApi(`/lookup/list/menusType`, {
        method: 'GET'
    });
}

export function updateColor(color) {
    return authApi(`/lookup/updateColor`, {
        method: "POST",
        body: color
    })
}

export function getColor() {
    return authApi(`/lookup/getColor`, {
        method: 'GET'
    });
}

//BankList
export function getBanks() {
    return authApi(`/lookup/banks`, {
        method: 'GET'
    });
}

export function createBanks(payload) {
    return authApi(`/lookup/createBanks`, {
        method: "POST",
        body: payload
    })
}

export function updateBanks(payload, bankId) {
    return authApi(`/lookup/updateBanks?bankId=${bankId}`, {
        method: "POST",
        body: payload
    })
}

export function getBanksList() {
    return authApi(`/lookup/list/banks`, {
        method: 'GET'
    });
}

export function deleteBank(id) {
    return authApi(`/lookup/delete-bank?id=${id}`, {
        method: 'DELETE'
    });
}

//Reasons
export function getReasons(type) {
    return authApi(`/lookup/reasons?type=${type}`, {
        method: 'GET'
    });
}

export function createReason(payload) {
    return authApi(`/lookup/createReason`, {
        method: "POST",
        body: payload
    })
}

export function updateReason(payload, reasonId) {
    return authApi(`/lookup/updateReason?reasonId=${reasonId}`, {
        method: "POST",
        body: payload
    })
}

export function getReasonsList() {
    return authApi(`/lookup/list/reasons`, {
        method: 'GET'
    });
}

export function deleteReason(id) {
    return authApi(`/lookup/delete-reason?id=${id}`, {
        method: 'DELETE'
    });
}

//Country
export function getCountryReg(token) {
    return authApi(`/register/country?token=${token}`, {
        method: 'GET'
    });
}

export function getCountry() {
    return authApi(`/lookup/country`, {
        method: 'GET'
    });
}

export function getNewPartnerCountry() {
    return authApi(`/lookup/new-partner-country`, {
        method: 'GET'
    });
}

export function getNewPartnerCity(project) {
    return authApi(`/lookup/new-partner-city?project=${project}`, {
        method: 'GET'
    });
}

export function createCountry(payload) {
    return authApi(`/lookup/createCountry`, {
        method: "POST",
        body: payload
    })
}

export function updateCountry(payload, countryId) {
    return authApi(`/lookup/updateCountry?countryId=${countryId}`, {
        method: "POST",
        body: payload
    })
}

export function getCountryList() {
    return authApi(`/lookup/list/country`, {
        method: 'GET'
    });
}

export function deleteCountry(id) {
    return authApi(`/lookup/delete-country?id=${id}`, {
        method: 'DELETE'
    });
}

export function getReasonsLookup() {
    return authApi(`/lookup/reasons`, {
        method: 'GET'
    });
}

export function getReasonForCompany() {
    return authApi(`/lookup/partner/reasons`, {
        method: 'GET'
    });
}

//
export function getVehicleLookup() {
    return authApi(`/lookup/vehicle`, {
        method: 'GET'
    });
}

export function getPartnerLookup(work_type, project) {
    return authApi(`/cashdeposit/partners?work_type=${work_type}&project=${project}`, {
        method: 'GET'
    });
}

export function getPartnerOthersLookup(work_type, project) {
    return authApi(`/cashdeposit/partners-others?work_type=${work_type}&project=${project}`, {
        method: 'GET'
    });
}

export function getPartnerTicketLookup(work_type, project, city, zone) {
    return authApi(`/cashdeposit/partners-ticket?work_type=${work_type}&project=${project}&city=${city}&zone=${zone}`, {
        method: 'GET'
    });
}

export function getPartnerVehicleLookup(work_type, project) {
    return authApi(`/cashdeposit/partners-vehicle?work_type=${work_type}&project=${project}`, {
        method: 'GET'
    });
}

export function getPartnerNewLookup(work_types, project, city, zone) {
    return authApi(`/cashdeposit/partners-new-two`, {
        method: 'POST',
        body: {
            project,
            city,
            zone,
            work_types
        }
    });
}

export function getNewPartnerLookup(work_type, project, city, zone, from) {
    return authApi(`/cashdeposit/partners-new`, {
        method: 'POST',
        body: {
            project,
            city,
            zone,
            work_type,
            from
        }
    });
}

export function getAllClients() {
    return authApi(`/cashdeposit/client/lookup`, {
        method: 'GET'
    });
}

//Cities
export function getCities() {
    return authApi(`/lookup/cities`, {
        method: 'GET'
    });
}

export function createCities(payload) {
    return authApi(`/lookup/createCities`, {
        method: "POST",
        body: payload
    })
}

export function updateCities(payload, cityId) {
    return authApi(`/lookup/updateCities?cityId=${cityId}`, {
        method: "POST",
        body: payload
    })
}

export function getCitiesList() {
    return authApi(`/lookup/list/cities`, {
        method: 'GET'
    });
}

export function deleteCities(id) {
    return authApi(`/lookup/delete-cities?id=${id}`, {
        method: 'DELETE'
    });
}

export function getCityProject(id) {
    return authApi(`/lookup/city-project?id=${id}`, {
        method: 'GET'
    });
}

//Zones
export function getZones() {
    return authApi(`/lookup/zones`, {
        method: 'GET'
    });
}

export function createZones(payload) {
    return authApi(`/lookup/createZones`, {
        method: "POST",
        body: payload
    })
}

export function updateZones(payload, zoneId) {
    return authApi(`/lookup/updateZones?zoneId=${zoneId}`, {
        method: "POST",
        body: payload
    })
}

export function getZonesList() {
    return authApi(`/lookup/list/zones`, {
        method: 'GET'
    });
}

export function deleteZones(id) {
    return authApi(`/lookup/delete-zones?id=${id}`, {
        method: 'DELETE'
    });
}

// Expense
export function getExpenseType() {
    return authApi(`/lookup/expenseType`, {
        method: 'GET'
    });
}

export function createExpense(payload) {
    return authApi(`/lookup/createExpense`, {
        method: "POST",
        body: payload
    })
}

export function updateExpense(payload, expenseId) {
    return authApi(`/lookup/updateExpense?expenseId=${expenseId}`, {
        method: "POST",
        body: payload
    })
}

export function getExpenseTypeList() {
    return authApi(`/lookup/list/expenseType`, {
        method: 'GET'
    });
}

export function deleteExpese(id) {
    return authApi(`/lookup/delete-expense?id=${id}`, {
        method: 'DELETE'
    });
}

//LeaveType
export function getLeaveType() {
    return authApi(`/lookup/leaveType`, {
        method: 'GET'
    });
}

export function createLeaveType(payload) {
    return authApi(`/lookup/createLeaveType`, {
        method: "POST",
        body: payload
    })
}

export function updateLeaveType(payload, id) {
    return authApi(`/lookup/updateLeaveType?id=${id}`, {
        method: "POST",
        body: payload
    })
}

export function getLeaveTypeList() {
    return authApi(`/lookup/list/leaveTypes`, {
        method: 'GET'
    });
}

export function deleteLeaveType(id) {
    return authApi(`/lookup/delete-leaveType?id=${id}`, {
        method: 'DELETE'
    });
}

//HelpDesk
export function getHelpDesk() {
    return authApi(`/lookup/helpDesks`, {
        method: 'GET'
    });
}

export function getAllHelpDeskApprover() {
    return authApi(`/lookup/helpDesks_approver`, {
        method: 'GET'
    });
}

export function createHelpDesk(payload) {
    return authApi(`/lookup/createHelpDesk`, {
        method: "POST",
        body: payload
    })
}

export function updateHelpDesk(payload, id) {
    return authApi(`/lookup/updateHelpDesk?id=${id}`, {
        method: "POST",
        body: payload
    })
}

export function getHelpDeskList() {
    return authApi(`/lookup/list/helpDesks`, {
        method: 'GET'
    });
}

export function deleteHelpDesk(id) {
    return authApi(`/lookup/delete-helpDesk?id=${id}`, {
        method: 'DELETE'
    });
}

export function getHelpDeskManagers(id) {
    return authApi(`/lookup/manager-helpDesk?id=${id}`, {
        method: 'GET'
    });
}

//Broadcast
export function getAllMessage() {
    return authApi(`/broadcast/list`, {
        method: 'GET'
    });
}

export function saveBroadcast(payload) {
    return authApi(`/broadcast/save`, {
        method: "POST",
        body: payload
    })
}

export function updateBroadcast(payload, id) {
    return authApi(`/broadcast/update?id=${id}`, {
        method: "POST",
        body: payload
    })
}

export function sendBroadcast(filters, country, partnerId, id) {
    return authApi(`/broadcast/send?`, {
        method: 'POST',
        body: {
            project: filters.project,
            city: filters.city,
            zone: filters.zone,
            work_types: filters.work_types,
            country,
            partner_id: partnerId,
            id
        }
    });
}

// Bankinfo
export function saveMode(modeId) {
    return authApi(`/lookup/mode?modeId=${modeId}`, {
        method: "POST"
    })
}

export function getMode() {
    return authApi(`/lookup/get-mode`, {
        method: 'GET'
    });
}

export function getModeTypes() {
    return authApi(`/lookup/get-mode-types`, {
        method: 'GET'
    });
}

export function getBanksLookup(projectId) {
    return authApi(`/lookup/bank-lookup?projectId=${projectId}`, {
        method: 'GET'
    });
}

//Carousel
export function getAllCarousel() {
    return authApi(`/carousel/list`, {
        method: 'GET'
    });
}

export function createCarousel(payload) {
    return authApi(`/carousel/save`, {
        method: "POST",
        body: payload
    })
}

export function updateCarousel(payload, id) {
    return authApi(`/carousel/update?id=${id}`, {
        method: "POST",
        body: payload
    })
}

export function deleteCarousel(id) {
    return authApi(`/carousel/delete?id=${id}`, {
        method: 'DELETE'
    });
}

export function getCarousel(id) {
    return authApi(`/carousel/details?id=${id}`, {
        method: 'GET'
    });
}

//VehicleType
export function getVehicleType() {
    return authApi(`/lookup/vehicles`, {
        method: 'GET'
    });
}

export function createVehicleType(payload) {
    return authApi(`/lookup/saveVehicleType`, {
        method: "POST",
        body: payload
    })
}

export function updateVehicleType(payload, vehicleTypeId) {
    return authApi(`/lookup/updateVehicleType?vehicleTypeId=${vehicleTypeId}`, {
        method: "POST",
        body: payload
    })
}

export function getVehicleTypeList() {
    return authApi(`/lookup/list/vehicles`, {
        method: 'GET'
    });
}

export function deleteVehicleType(id) {
    return authApi(`/lookup/delete-vehicle?id=${id}`, {
        method: 'DELETE'
    });
}

//InsuranceType
export function getInsuranceType() {
    return authApi(`/lookup/insurances`, {
        method: 'GET'
    });
}

export function createInsuranceType(payload) {
    return authApi(`/lookup/save-insurance`, {
        method: "POST",
        body: payload
    })
}

export function updateInsuranceType(payload, insuranceId) {
    return authApi(`/lookup/update-insurance?insuranceId=${insuranceId}`, {
        method: "POST",
        body: payload
    })
}

export function getInsuranceTypeList() {
    return authApi(`/lookup/list/insurances`, {
        method: 'GET'
    });
}

export function deleteInsuranceType(id) {
    return authApi(`/lookup/delete-insurance?id=${id}`, {
        method: 'DELETE'
    });
}

//HelpdeskTitle
export function getHelpdeskTitle() {
    return authApi(`/lookup/helpdesk-title`, {
        method: 'GET'
    });
}

export function createHelpdeskTitle(payload) {
    return authApi(`/lookup/save-helpdesk-title`, {
        method: "POST",
        body: payload
    })
}

export function updateHelpdeskTitle(payload, helpdesk_title_id) {
    return authApi(`/lookup/update-helpdesk-title?helpdesk_title_id=${helpdesk_title_id}`, {
        method: "POST",
        body: payload
    })
}

export function getHelpdeskTitleList() {
    return authApi(`/lookup/list/helpdesk-title`, {
        method: 'GET'
    });
}

export function deleteHelpdeskTitle(id) {
    return authApi(`/lookup/delete-helpdesk-title?id=${id}`, {
        method: 'DELETE'
    });
}

//EMIExpenses
export function getEMICategoryLookup() {
    return authApi(`/lookup/emi-category`, {
        method: 'GET'
    });
}

export function getEMIExpensesLookup(id) {
    return authApi(`/lookup/emi-expense?category_id=${id}`, {
        method: 'GET'
    });
}

export function saveEMIExpenses(payload) {
    return authApi(`/lookup/save-emi-expense`, {
        method: "POST",
        body: payload
    })
}

export function updateEMIExpenses(payload, id) {
    return authApi(`/lookup/update-emi-expense?id=${id}`, {
        method: "POST",
        body: payload
    })
}

export function getEMIExpenses(id) {
    return authApi(`/lookup/list/emi-expense?id=${id}`, {
        method: 'GET'
    });
}

export function deletEMIExpenses(id) {
    return authApi(`/lookup/delete-emi-expense?id=${id}`, {
        method: 'DELETE'
    });
}

//Incentives
export function getIncentiveList() {
    return authApi(`/lookup/list/incentive`, {
        method: 'GET'
    });
}

export function saveIncentive(payload) {
    return authApi(`/lookup/save-incentive`, {
        method: "POST",
        body: payload
    })
}

export function updateIncentive(payload, id) {
    return authApi(`/lookup/update-incentive?id=${id}`, {
        method: "POST",
        body: payload
    })
}

export function deleteIncentive(id) {
    return authApi(`/lookup/delete-incentive?id=${id}`, {
        method: 'DELETE'
    });
}

//Category
export function getCategory() {
    return authApi(`/billers/category`, {
        method: 'GET'
    });
}

export function createCategory(payload) {
    return authApi(`/billers/create`, {
        method: "POST",
        body: payload
    })
}

export function updateCategory(payload, categoryId) {
    return authApi(`/billers/update?categoryId=${categoryId}`, {
        method: "POST",
        body: payload
    })
}

export function getCategoryList() {
    return authApi(`/billers/list/category`, {
        method: 'GET'
    });
}

export function deleteCategory(id) {
    return authApi(`/billers/delete-category?id=${id}`, {
        method: 'DELETE'
    });
}

//Billers
export function saveBiller(payload) {
    return authApi(`/billers/save-biller`, {
        method: "POST",
        body: payload
    })
}

export function updateBiller(payload, id) {
    return authApi(`/billers/update-biller?id=${id}`, {
        method: "POST",
        body: payload
    })
}

export function listBiller() {
    return authApi(`/billers/list-biller`, {
        method: 'GET'
    });
}

export function billerProjects(id) {
    return authApi(`/billers/biller-project?id=${id}`, {
        method: 'GET'
    });
}

export function deleteBiller(id) {
    return authApi(`/billers/delete-biller?id=${id}`, {
        method: 'DELETE'
    });
}

export function billerLookup() {
    return authApi(`/billers/lookup-biller`, {
        method: 'GET'
    });
}

export function getManagerBankLookup(managerId) {
    return authApi(`/manager/bank-lookup?managerId=${managerId}`, {
        method: 'GET'
    });
}

//Payment Mode
export function getPaymentMode() {
    return authApi(`/billers/payment-mode`, {
        method: 'GET'
    });
}

export function createPaymentMode(payload) {
    return authApi(`/billers/create-payment-mode`, {
        method: "POST",
        body: payload
    })
}

export function updatePaymentMode(payload, modeId) {
    return authApi(`/billers/update-payment-mode?modeId=${modeId}`, {
        method: "POST",
        body: payload
    })
}

export function getPaymentModeList() {
    return authApi(`/billers/list/payment-mode`, {
        method: 'GET'
    });
}

export function deletePaymentMode(id) {
    return authApi(`/billers/delete-payment-mode?id=${id}`, {
        method: 'DELETE'
    });
}

// COD Bankinfo
export function saveCodBankInfo(payload) {
    return authApi(`/lookup/save-cod-bank`, {
        method: "POST",
        body: payload
    })
}

export function updateCodBankInfo(payload, bankId) {
    return authApi(`/lookup/update-cod-bank?bankId=${bankId}`, {
        method: "POST",
        body: payload
    })
}

export function getCodSupBankLookup(superviser_id) {
    return authApi(`/lookup/cod-bank-info-pro?superviserId=${superviser_id}`, {
        method: 'GET'
    });
}

export function getUpdateCodBankInfoList(projectId) {
    return authApi(`/lookup/cod-bank-info-list?projectId=${projectId}`, {
        method: 'GET'
    });
}

export function getCodBanksLookup(type) {
    return authApi(`/lookup/cod-bank-lookup?type=${type}`, {
        method: 'GET'
    });
}

//Employee
export function saveEmployee(payload) {
    return authApi(`/employee/save`, {
        method: "POST",
        body: payload
    })
}

export function updateEmployee(payload) {
    return authApi(`/employee/update`, {
        method: "POST",
        body: payload
    })
}

export function getEmployeeList() {
    return authApi(`/employee/list`, {
        method: 'POST'
    });
}

export function getEmployeelookup() {
    return authApi(`/employee/lookup`, {
        method: 'GET'
    });
}

export function getEmployeeId() {
    return authApi(`/employee/employee_id`, {
        method: 'GET'
    });
}

export function getEmployeeSalary(id) {
    return authApi(`/employee/emp-salary?id=${id}`, {
        method: 'GET'
    });
}

export function deleteEmployee(id) {
    return authApi(`/employee/delete?id=${id}`, {
        method: 'DELETE'
    });
}

export function downloadEmployees() {
    return authApi(`/excel/employees`, {
        method: 'POST'
    });
}